import { render, staticRenderFns } from "./ExOverviewStatusCellRenderer.vue?vue&type=template&id=49bd70b0&"
import script from "./ExOverviewStatusCellRenderer.vue?vue&type=script&lang=ts&"
export * from "./ExOverviewStatusCellRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports